import Notice from "./Notice.svelte"
import { closeBottomPopup, openBottomPopup } from "./bottomPopup.module"

export type NoticeTypes = "regular" | "warning" | "error"

export function createNotice(props: {
    headline?: string
    detail?: string
    type?: NoticeTypes
}) {
    openBottomPopup(Notice, props)
}
